import type { WorkflowEnginePin } from "@/api";

/** Epoch identifies a request attempt, not the profile offered for selection. */
export const sameWorkflowProfile = (a: WorkflowEnginePin, b: WorkflowEnginePin) =>
  a.engine === b.engine && a.profile_id === b.profile_id
  && a.profile_version === b.profile_version && a.profile_hash === b.profile_hash;
